import styled from 'styled-components';

export const TogglerBody = styled.div`
    width: 50px;
    height: 31px;
    border-radius: 18px;
    padding: 0 2px;
    background-color: ${props => (props.state ? '#fc3d40' : 'rgba(239, 240, 242, 0.18)')};
    display: flex;
    justify-content: ${props => (props.state ? 'flex-end' : 'flex-start')};
    align-items: center;

    transition: all ease-in 0.2s;
    cursor: pointer;
`;

export const TogglerIndicator = styled.div`
    width: 27px;
    height: 27px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    border-radius: 50px;
    transition: all ease-in 0.2s;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Toggler/style.js